import React, { useState } from 'react';
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  ListItem,
} from '@material-tailwind/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import { Link } from 'react-router-dom';

const NavMenu = ({ mainTitle, subMenuItems }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      <Menu
        open={isMenuOpen}
        handler={setIsMenuOpen}
        placement='bottom'
        allowHover={true}
      >
        <MenuHandler>
          <ListItem
            className='flex items-center gap-2 py-2 pr-4 font-medium text-gray-900'
            selected={isMenuOpen}
          >
            {mainTitle}
            <ChevronDownIcon
              strokeWidth={3}
              className={`hidden h-3 w-3 transition-transform lg:block ${
                isMenuOpen ? 'rotate-180' : ''
              }`}
            />
          </ListItem>
        </MenuHandler>
        <MenuList>
          {subMenuItems.map((subNavItem) => (
            <MenuItem className='py-3' key={subNavItem.link}>
              <Link
                to={subNavItem.link}
                className='text-gray-300 hover:bg-darkest px-3 py-3 rounded-md text-base font-medium'
              >
                {subNavItem.title}
              </Link>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};

export default NavMenu;
